export default "__VITE_ASSET__DrCoUw9d__"